import React from 'react';
import styles from './FixedFooter.scss';

export const FixedFooter = (props) => (
    <div className={styles.fixedFooter} data-cy="fixedFooter">
        <div className={props.className} data-cy="fixedFooter-children">
            {props.children}
        </div>
    </div>
);
